/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2024
 */

import { Component, Router } from 'llama'

export default class OnboardingFooter extends Component {
  constructor (opt) {
    super({
      ...opt,
      html: () => (
        this.back
          ? `<button id="onboarding-return">${this.context.onboarding.return}</button>`
          : ''
      ) + (
        this.next
          ? `<button id="onboarding-confirm">${this.context.onboarding.continue}</button>`
          : ''
      ) + (
        this.submit
          ? `<button id="onboarding-submit">${this.context.onboarding.submit}</button>`
          : ''
      )
    })
    this.back = opt.back
    this.submit = opt.submit
    this.next = opt.next
  }

  init () {
    if (this.back) {
      this.addEvtById('onboarding-return', 'click', () => this.back())
    }
    if (this.next) {
      this.addEvtById('onboarding-confirm', 'click', () => this.next())
    }
    if (this.submit) {
      this.addEvtById('onboarding-submit', 'click', () => this.submit())
    }

    this.on(Router.LAND, (params) => {
      this.config = params.config
    })
  }
}
